import { FormSkeleton } from '@globaleris/ui.library'
import { List, ListItem, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  list: {
    '& > *': {
      display: 'table'
    }
  }
}))

interface LeadsProfileDetailLeftPanelProps {
  isLoading?: boolean
  code: string
  description?: string
  toll?: string
  breakdownLevel?: string
  weightedType?: string
  commodity?: string
  productCode: string
  profileCode?: string
}

export const LeadsProfileDetailLeftPanel: React.FC<LeadsProfileDetailLeftPanelProps> = ({
  isLoading = false,
  code,
  description,
  breakdownLevel,
  weightedType,
  commodity,
  toll,
  productCode,
  profileCode = ''
}) => {
  const classes = useStyles()
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'leads'])

  return (
    <>
      {isLoading ? (
        <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={3} />
      ) : (
        <>
          <Typography variant="h1" color="primary" noWrap>
            {t('leads:components.leadsProfileDetail.leftColumn.title')}
          </Typography>
          <List className={classes.list}>
            <ListItem divider disableGutters>
              <Typography variant="h2">
                {t('leads:components.leadsProfileDetail.leftColumn.subtitle')}
              </Typography>
            </ListItem>
            <ListItem divider disableGutters>
              <Typography variant="caption">
                {t('leads:components.leadsProfileDetail.leftColumn.captions.code')}
              </Typography>
              <Typography variant="body2">{code}</Typography>
            </ListItem>
            {description && (
              <ListItem divider disableGutters>
                <Typography variant="caption">
                  {t('leads:components.leadsProfileDetail.leftColumn.captions.description')}
                </Typography>
                <Typography variant="body2">{description}</Typography>
              </ListItem>
            )}
            {toll && (
              <ListItem divider disableGutters>
                <Typography variant="caption">
                  {t('leads:components.leadsProfileDetail.leftColumn.captions.toll')}
                </Typography>
                <Typography variant="body2">{toll}</Typography>
              </ListItem>
            )}
            {breakdownLevel && (
              <ListItem divider disableGutters>
                <Typography variant="caption">
                  {t('leads:components.leadsProfileDetail.leftColumn.captions.breakdownLevel')}
                </Typography>
                <Typography variant="body2">{breakdownLevel}</Typography>
              </ListItem>
            )}
            {weightedType && (
              <ListItem divider disableGutters>
                <Typography variant="caption">
                  {t('leads:components.leadsProfileDetail.leftColumn.captions.weightedType')}
                </Typography>
                <Typography variant="body2">{weightedType}</Typography>
              </ListItem>
            )}
            {commodity && (
              <ListItem divider disableGutters>
                <Typography variant="caption">
                  {t('leads:components.leadsProfileDetail.leftColumn.captions.commodity')}
                </Typography>
                <Typography variant="body2">{commodity}</Typography>
              </ListItem>
            )}
            <ListItem divider disableGutters>
              <Typography variant="caption">
                {t('leads:components.leadsProfileDetail.leftColumn.captions.productCode')}
              </Typography>
              <Typography variant="body2">{productCode}</Typography>
            </ListItem>
            {profileCode && (
              <ListItem divider disableGutters>
                <Typography variant="caption">
                  {t('leads:components.leadsProfileDetail.leftColumn.captions.profileCode')}
                </Typography>
                <Typography variant="body2">{profileCode}</Typography>
              </ListItem>
            )}
          </List>
        </>
      )}
    </>
  )
}
